import { Component, HostListener, VERSION } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from './Service/Common/toastr.service';
import { AllModule } from './Model/Common/AllModule';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './Model/Common/LocalStorageService';
import { FCMMessageRegistration } from './Model/Common/FCMMessageRegistration';
import { getWindow } from 'ssr-window';
import { RiderService } from './Service/Rider/rider.service';
import { APIFactoryEndPoints } from './Model/Common/apifactory-end-points';
import { BehaviorSubject, Subscription, filter, interval } from 'rxjs';
import { Constant } from './Common/constant';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './Base/confirmation-dialog/confirmation-dialog.component';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { NewOrderDialogComponent } from './Module/Shipping/new-order-dialog/new-order-dialog.component';
import { logOutApp, pushPullData, StopMessageAndBeep } from 'src/myfunc';
import { RiderDetails } from './Model/Rider/rider-details';
import { verify } from 'crypto';
import { RiderLocation } from './Model/Common/RiderLocation';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { HelpDialogComponent } from './Base/help-dialog/help-dialog.component';
import { ShippingManagerService } from './Service/Shipping/shipping-manager.service';
import { RatingsDto } from './Model/Ratings/ratings-dto';
import { NewOrderMapDialogComponent } from './Module/Shipping/new-order-map-dialog/new-order-map-dialog.component';
import { WebSocketService } from './Common/WebSocketService';
import { JwtService } from './Service/Common/jwt.service';
import jwt_decode from 'jwt-decode';
import { GoogleCustomer } from './Model/Common/google-customer';
import { AppConfigService } from './Service/Configuration/app-config.service';
import { initializeApp } from "firebase/app";
import { SessionStorageService } from './Model/Common/SessionStorageService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  styles: [
    `
      .star {
        position: relative;
        display: inline-block;
        font-size: 20px;
        color: #d3d3d3;
      }
      .full {
        color: green;
        font-size: 20px;
      }
      .half {
        position: absolute;
        display: inline-block;
        overflow: hidden;
        color: green;
        font-size: 20px;
      }
    `,
  ],
})
export class AppComponent {
  title = 'Mobitrix Rider UI';

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  lastLong: string = '';
  lastLat: string = '';
  longLatSavedCnt: number = 0;
  name: string = null;
  id: string = null;
  showSignIn: boolean = true;
  showPage: boolean = false;
  constant: Constant = new Constant();

  inLoginPage: boolean = false;
  menuHeader: any = [];
  appitemsTravel: any = [];
  allModule: AllModule[] = [
    { label: 'Home', internalName: 'dashboard', image: 'dashboard.svg' },
    {
      label: 'Shipping',
      internalName: 'shipping-details',
      image: 'shippingmanager.svg',
    },
    {
      label: 'Trips',
      internalName: 'rider-orders',
      image: 'datewisereport.svg',
    },
    // { label: 'Trips', internalName: 'trips', image: 'shippingreport.svg' },
    { label: 'Account', internalName: 'rider-accounts', image: 'account.svg' },
    // { label: 'Ratings', internalName: 'ratings', image: 'ratings.svg' },
  ];

  allModuleWithDashboard: AllModule[] = [
    { label: 'Home', internalName: 'dashboard', image: 'dashboard.svg' },
  ];
  fCMMessageRegistration: FCMMessageRegistration = new FCMMessageRegistration();
  riderLocation: RiderLocation = new RiderLocation();
  token: string = '';
  signedIn: boolean = false;
  fcmResponse: any;
  nos: number = 0;
  tempData: string;
  manageBeepAndTextList: string;
  payL: any = '';
  cntMessagesReadAndBeep: number = 0;
  currentMessage = new BehaviorSubject(this.payL);
  hideMatBadge: boolean = true;
  confirmDialogOpen: boolean = false;
  channel: BroadcastChannel;
  intervalId: NodeJS.Timeout;
  message: string = '';
  riderDetails: RiderDetails = new RiderDetails();
  page: string = '';

  riderEmail: string;
  DashboardStatus: boolean = false;
  selectedMenu: any;

  displayedColumns: string[] = ['byCustomer', 'byLocation'];
  summaryData: RatingsDto[] = [];
  avgRatingByCustomerValue: number = 0;
  avgRatingByLocationValue: number = 0;

  tenantId: string | null | undefined;

  private onchangeStatusSubscription: Subscription;
  private getRiderSubscription: Subscription;
  private onchangeToggleStatusSubscription: Subscription;
  private getRiderRatingsSubscription: Subscription;

  inSignInOrUp: boolean = true;
  constructor(
    public persistenceService: LocalStorageService,
    private toastrService: ToastrService,
    private router: Router,
    private riderService: RiderService,
    private apiUrl: APIFactoryEndPoints,
    private dialog: MatDialog,
    public createRiderService: RiderService,
    private shippingManagerService: ShippingManagerService,
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    private webSocketService: WebSocketService,
    private route: ActivatedRoute,
    private jwtService: JwtService,
    private appConfig: AppConfigService
  ) {
    // this.testPush('1234');

    this.persistenceService.set('isVerified', JSON.stringify('false'));
    this.persistenceService.set('active_rider_status', JSON.stringify('false'));
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (
          window.location.href.includes('/login') ||
          window.location.href.includes('/pre-app-and') ||
          window.location.href.includes('/rider-details')
        ) {
          this.signedIn = false;
        } else {
          this.signedIn = true;
          this.inLoginPage = false;
          this.testPush(this.persistenceService.get('google_email'));
        }
      }
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.inLoginPage = event.url.includes('/login') || event.url.includes('/unauthorized');
    });
  }

  async ngOnInit() {
    const source = this.getParamValueQueryString('source');
    console.log('Source from query string:', source);

    if (source) {
      this.sessionStorage.set('tenantId', source);
    }

    const tenantId = this.sessionStorage.get('tenantId');

    console.log('Tenant ID from session storage:', tenantId);

    if (!tenantId) {
      this.router.navigate(['/unauthorized']);
      return;
    }
    const firebaseConfig = this.appConfig.setting.firebase;
    if (firebaseConfig) {
      initializeApp(firebaseConfig);
      console.log('✅ Firebase initialized with dynamic config');
    } else {
      console.error('⚠️ Firebase config not loaded!');
    }
    this.route.queryParams.subscribe(params => {
      let token = params['id_token'];
      let accessToken = params['access_token'];

      // Fallback if Angular fails to parse it
      if (!token) {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get('id_token');
        accessToken = urlParams.get('access_token');
      }

      // alert('Token: ' + token);

      if (token) {
        try {
          const decoded: any = jwt_decode(token);
          console.log('Decoded JWT:', decoded);
          this.jwtService.saveAccessToken(accessToken);
          this.callLogin(decoded);

          // Optionally clean up the URL
          // this.router.navigate(['/dashboard'], { replaceUrl: true });
        } catch (error) {
          console.error('Invalid token:', error);
          this.onAccountOperation();
        }
      } else {
        this.onAccountOperation();
      }
    });
    // this.onAccountOperation();




    //this.riderDetails.isVerified=false;
    //this.persistenceService.set('google_email','manasmandal1430@gmail.com')
    this.persistenceService.set('manageBeepAndTextList', '');
    // if (this.getOS() != 'Android')
    //   this.runContiniously();
    this.channel = new window.BroadcastChannel('bg-notification');
    this.channel.addEventListener('message', (e) => {
      this.nos = this.nos + 1;
      console.log('Received Message Title : ' + e.data.payload.notification.title);
      console.log('Received Message Body : ' + e.data.payload.notification.body);
      console.log('Received Message Data : ' + e.data.payload.data);
      console.log('Received Message messageBody : ' + e.data.payload.data.messageBody);
      // Parse the message body into a structured object
      const parsedMessage = this.parseMessageBody(e.data.payload.data.messageBody.toString());
      console.log('ParsedMsg: ' + parsedMessage);
      if (e.data.payload.notification.title == 'Rider Notification') {
        this.manageBeepAndTextList = this.persistenceService.get('manageBeepAndTextList');
        let message = e.data.payload.data.messageBody;
        this.webOrderRequest(parsedMessage.refNo, message, parsedMessage.beep, parsedMessage.readMessage, parsedMessage.forModule);
      }
      if (e.data.payload.notification.title == 'Rider Verification Notification') {
        this.RiderVerifiedWeb(e.data.payload.data.messageBody);
      }

      // if (e.data.payload.notification.title == "Cancel Message") {
      //   let refNo = e.data.payload.data.refNo;
      //   let forModule = e.data.payload.data.forModule;
      //   this.cancelMessage(refNo, forModule);
      // }
    });
    if (
      (this.getOS() != 'Android' &&
        this.appConfig.setting.baseURL.includes('localhost') == true) ||
      this.appConfig.setting.baseURL.includes('rider.mobitrix.net') == true
    ) {
      this.requestPermission();
      this.listen();
    }
    // if (this.persistenceService.get("email") != "")
    //   this.router.navigateByUrl("dashboard")
    // else
    //   this.router.navigateByUrl("rider-details")

    // if (this.getOS() == 'Android') {
    //   if (this.getQueryVariable('source') == 'NA')
    //     this.router.navigateByUrl('rider-details');
    //   else {
    //     this.persistenceService.set(
    //       'google_email',
    //       JSON.stringify(this.getQueryVariable('source').replaceAll('"', ''))
    //     );
    //     this.persistenceService.set(
    //       'google_item',
    //       JSON.stringify(this.getQueryVariable('fullName').replaceAll('"', ''))
    //     );
    //     this.persistenceService.set(
    //       'google_id',
    //       JSON.stringify(this.getQueryVariable('source').replaceAll('"', ''))
    //     );
    // if (this.id == null) {
    //   this.id = this.persistenceService.get("google_email");
    // }

    //     if (this.id) this.getRiderByEmail(this.id);

    //     // this.router.navigateByUrl("dashboard")
    //   }
    // } else {
    //   this.onAccountOperation();
    // }
    // this.openNav();
    this.persistenceService.set('OS', this.getOS());
    console.log(this.persistenceService.get('OS'));
    localStorage.setItem('OS', this.getOS());
    this.riderEmail = JSON.parse(this.persistenceService.get('google_email'));

    if (this.persistenceService.get('active_rider_status'))
      this.DashboardStatus = JSON.parse(
        this.persistenceService.get('active_rider_status')
      );

    if (this.persistenceService.get('google_email')) {
      this.initializeMenu();
    }
    this.riderDetails = JSON.parse(
      this.persistenceService.get('rider_details')
    );

    this.persistenceService.set(
      'isVerified',
      JSON.stringify(this.riderDetails?.isVerified)
    );
    this.persistenceService.set(
      'active_rider_status',
      this.riderDetails?.activeStatus?.toString()
    );
  }

  ngAfterViewInit() {
    // alert(this.signedIn)
    if (this.getOS() != 'Android') {
      const currentToken = this.persistenceService.get('FirebaseToken');

      if (this.token != currentToken) this.token = currentToken;

      this.fCMMessageRegistration = new FCMMessageRegistration();
      this.fCMMessageRegistration.locId = parseInt(
        this.persistenceService.get('locId')
      );

      if (this.persistenceService.get('google_email') != undefined)
        this.fCMMessageRegistration.locCusId = JSON.parse(
          this.persistenceService.get('google_email')
        );
      else
        this.fCMMessageRegistration.locCusId =
          this.persistenceService.get('DeviceID');
      this.fCMMessageRegistration.token = currentToken;

      if (
        this.persistenceService.get('DeviceID') == null ||
        this.persistenceService.get('DeviceID') == ''
      ) {
        this.persistenceService.set('DeviceID', this.generateUniqueID());
      }

      this.fCMMessageRegistration.deviceId =
        this.persistenceService.get('DeviceID');
      this.fCMMessageRegistration.deviceType = 'Web';

      document.getElementById('deviceId').innerHTML =
        this.persistenceService.get('DeviceID');

      this.saveFCMTokenAndDeviceData(this.token, 'Web');

      this.getLatLongWeb();
    } else {
      console.log('Hello from ReceivedDeviceInfo1=');
      const currentToken = localStorage.getItem('FirebaseToken');
      console.log('Hello from ReceivedDeviceInfo2=');
      this.fCMMessageRegistration = new FCMMessageRegistration();
      this.fCMMessageRegistration.locId = parseInt(
        this.persistenceService.get('locId')
      );
      if (this.persistenceService.get('google_email') != undefined)
        this.fCMMessageRegistration.locCusId = this.persistenceService
          .get('google_email')
          .replaceAll('"', '');
      else
        this.fCMMessageRegistration.locCusId = this.persistenceService
          .get('DeviceID')
          .replaceAll('"', '');
      this.fCMMessageRegistration.token = currentToken;
      this.fCMMessageRegistration.deviceType = 'Mob';
      if (localStorage.getItem('DeviceID') != null) {
        this.fCMMessageRegistration.deviceId = localStorage.getItem('DeviceID');
      } else this.fCMMessageRegistration.deviceId = 'NA';
      document.getElementById('deviceId').innerHTML =
        this.persistenceService.get('DeviceID');

      //this.saveFCMTokenAndDeviceData(this.token, 'And');
    }

    if (this.persistenceService.get('OS') == 'Android')
      this.id = this.persistenceService.get('google_email').replaceAll('"', '');
    else this.id = JSON.parse(this.persistenceService.get('google_email'));

    if (this.persistenceService.get('rider_details') != null) {
      console.log("executed my block")
      if (JSON.parse(this.persistenceService.get('rider_details')).isVerified) {
        console.log(
          'Rider Verified2 : ' +
          JSON.parse(this.persistenceService.get('rider_details')).isVerified
        );
        this.appitemsTravel = this.allModule;
      } else {
        this.appitemsTravel = this.allModuleWithDashboard;
      }
    } else {
      this.appitemsTravel = this.allModule;
    }
  }

  onAccountOperation() {
    this.name = JSON.parse(this.persistenceService.get('google_item'));
    this.id = JSON.parse(this.persistenceService.get('google_email'));
    let riderDetails = JSON.parse(this.persistenceService.get('rider_details'));

    let currentPath = window.location.pathname;
    // && ['/rider-details', '/login'].includes(currentPath)
    if (this.name && riderDetails) {
      this.page = 'Dashboard';
      this.showSignIn = false;
      this.router.navigate(['']);
    } else if (this.name && !riderDetails) {
      this.page = 'Rider Details';
      // this.router.navigate(['/rider-details']);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/rider-details']);
      });
    } else if (!this.name && !riderDetails) {
      this.name = null;
      this.id = null;
      this.showSignIn = true;
      // if (this.getOS() != 'Android') {
      this.router.navigate(['/login']);
      // }
    }
    this.persistenceService.set('page', this.page);

    this.router.events.forEach(async (event) => {
      if (event instanceof NavigationEnd) {
        if (window.location.href.includes('/login') || window.location.href.includes('/rider-details'))
          this.inSignInOrUp = true;
        else
          this.inSignInOrUp = false;

        if (window.location.href.includes('/login')) {
          this.showPage = true;
          this.inLoginPage = true;
        } else
          this.inLoginPage = false;

        const el = document.getElementById('navMenuBar');
        const el1 = document.getElementById('profile_btn');
        console.log(this.inLoginPage)
        if (this.inLoginPage || !riderDetails) {
          this.appitemsTravel = []
          // el.style.visibility = 'hidden';
          el.style.visibility = 'inherit';
          el1.style.marginLeft = 'auto';
          el.style.height = '60px';
          // this.idle.stop();
        } else {
          el.style.visibility = 'inherit';
          el.style.height = '60px';
          // this.idle.watch();
        }
      }
    });

    let formattedFromDate = '1999-01-01%2000:00:00';
    let formattedToDate = '3000-01-01%2023:59:59';
    if (this.id != null) {
      this.getRiderRatingsSubscription = this.shippingManagerService
        .getRiderRatingData(this.apiUrl.getRiderRatingByEmail, this.id, formattedFromDate, formattedToDate).subscribe((data) => {
          let rating: RatingsDto = new RatingsDto();
          rating.avgRatingByCustomer = 0;
          rating.avgRatingByLocation = 0;
          if (data.length > 0) {
            let totalRateByCustomer = 0;
            let totalRateByLocation = 0;
            data.forEach((e) => (totalRateByCustomer += e.toDeliveryBoy));
            this.avgRatingByCustomerValue = totalRateByCustomer / data.length;

            data.forEach((e) => (totalRateByLocation += e.toDeliveryBoy));
            this.avgRatingByLocationValue = 0;
          }
        });
    }
  }

  googleCustomer = new GoogleCustomer();
  isSignIn: boolean = false;

  callLogin(googleAuthUser: any) {
    this.isSignIn = false;
    localStorage.setItem("showSignIn", "true");
    console.log("ID: " + googleAuthUser.email);
    console.log("Name: " + googleAuthUser.name);
    console.log("Image URL: " + googleAuthUser.picture);
    console.log("Email: " + googleAuthUser.email);

    this.isSignIn = true;
    this.googleCustomer.id = googleAuthUser.email;
    this.googleCustomer.name = googleAuthUser.name;
    this.googleCustomer.email = googleAuthUser.email;
    this.googleCustomer.firstName = googleAuthUser.given_name;
    this.googleCustomer.lastName = googleAuthUser.family_name;
    this.googleCustomer.idToken = googleAuthUser.email;
    this.googleCustomer.authToken = googleAuthUser.nbf;
    this.googleCustomer.provider = "GOOGLE";

    console.log(this.googleCustomer);

    this.localStorage.set("google_loggedIn_details", JSON.stringify(this.googleCustomer));
    this.localStorage.set("google_email", JSON.stringify(this.googleCustomer.email));
    this.localStorage.set("google_item", JSON.stringify(this.googleCustomer.name));
    this.localStorage.set("google_id", JSON.stringify(this.googleCustomer.id));
    this.localStorage.set("google_provider", JSON.stringify(this.googleCustomer.provider));
    if (this.googleCustomer) {
      this.getRiderByEmail(this.googleCustomer.email);
    }
    else {
      this.isSignIn = false;
    }
  }

  getRiderByEmail(googleEmailId: string) {
    this.getRiderSubscription = this.riderService.getRiderByEmail(googleEmailId).subscribe((data) => {
      console.log('ACCC=' + data + '====' + googleEmailId);
      if (data) {
        this.riderDetails = data;
        console.log('ACCC1=' + data + '====' + this.riderDetails);
        this.persistenceService.set('rider_details', JSON.stringify(this.riderDetails));
        this.persistenceService.set('locId', this.riderDetails.fromLocationCode.toString());
        this.persistenceService.set('active_rider_status', this.riderDetails.activeStatus.toString());
        this.toastrService.showSuccessToast('Sucessfully Logged In');
        // this.router.navigateByUrl("dashboard");
        this.onAccountOperation();
      } else {
        this.onAccountOperation();
      }
    });
  }

  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.fcmResponse = payload;
      this.nos = this.nos + 1;
      this.toastrService.showSuccessToast('You have a new Notification');
      console.log('Message received.With Title', payload.notification.title);
      console.log('Message received.With Body', payload.notification.body);

      // Parse the message body into a structured object
      const parsedMessage = this.parseMessageBody(payload.data?.messageBody);
      console.log('Message received parsedMessage. ', parsedMessage);
      console.log('Received Message For Module: ' + parsedMessage.forModule);
      console.log('Received Beep: ' + parsedMessage.beep);
      console.log('Received Message readMessage: ' + parsedMessage.readMessage);
      console.log('Received Message refNo: ' + parsedMessage.refNo + '=====' + this.persistenceService.get('locId'));
      console.log('NOM=' + this.nos);
      if (this.nos > 0) {
        this.hideMatBadge = false;
      } else {
        this.hideMatBadge = true;
      }
      if (this.fcmResponse.notification.title == 'Rider Notification') {
        this.webOrderRequest(parsedMessage.refNo, payload.data?.messageBody, parsedMessage.beep, parsedMessage.readMessage, parsedMessage.forModule);
      }
      if (this.fcmResponse.notification.title == 'Cancel Message') {
        let refNo: string = parsedMessage.refNo;
        let forModule: string = parsedMessage.forModule;
        this.cancelMessage(refNo, forModule);
      }
      if (this.fcmResponse.notification.title == 'Rider Verification Notification') {
        this.RiderVerifiedWeb(payload.data?.messageBody);
      }
      this.currentMessage.next(payload);
    });
  }

  // Method to parse the message body and return an object with values
  parseMessageBody(body: string) {
    console.log("parse Message Body1 : " + body)
    const messageParts = body.split('===');
    console.log("parse Message Body2 : " + messageParts.length)

    return {
      message: messageParts[0],
      distance: messageParts[1]?.split(':')[1],
      price: messageParts[2]?.split(':')[1],
      fromAddress: messageParts[3]?.split(':')[1],
      toAddress: messageParts[4]?.split(':')[1],
      latitude: messageParts[5]?.split(':')[1],
      longitude: messageParts[6]?.split(':')[1],
      forModule: messageParts[7]?.split(':')[1],
      refNo: messageParts[8]?.split(':')[1],
      readMessage: messageParts[9]?.split(':')[1],
      beep: messageParts[10]?.split(':')[1],
      locId: messageParts[11]?.split(':')[1],
    };
  }

  @HostListener('window:SSEMessage', ['$event'])
  onMessage(event) {
    var data = JSON.parse(event.detail.resp);
    console.log('deviceId : ' + data.deviceId);
    console.log('message Title: ' + data.messageTitle);
    console.log('message Body : ' + data.messageBody);
    console.log('forModule : ' + data.forModule);
    console.log('transactionNo : ' + data.transactionNo);
    console.log('beepYesNo : ' + data.beepYesNo);
    console.log('readMessageYesNo : ' + data.readMessageYesNo);
    this.manageBeepAndTextList = this.persistenceService.get(
      'manageBeepAndTextList'
    );

    if (data.messageTitle == 'Rider Notification')
      this.webOrderRequest(
        data.transactionNo,
        data.messageBody,
        data.beepYesNo,
        data.readMessageYesNo,
        data.forModule
      );
    if (data.messageTitle == 'Cancel Message')
      this.cancelMessage(data.refNo, data.forModule);
    if (data.messageTitle == 'Rider Verification Notification') {
      this.RiderVerifiedWeb(data.messageBody);
    }
  }

  @HostListener('window:ReceivedPushedOrder', ['$event'])
  ReceivedPushedOrder(event) {
    console.log('Received Title=11=' + event.detail?.title);
    console.log('Received Body=22=' + event.detail?.body);
    console.log('Received Data=33=' + event.detail?.data);
    // Parse the message body into a structured object
    const parsedMessage = this.parseMessageBody(event.detail?.data);
    console.log('ParsedMessage: ' + parsedMessage);
    if (event.detail?.title == 'Rider Notification') {
      this.webOrderRequest(parsedMessage.refNo, event.detail?.data, parsedMessage.beep, parsedMessage.readMessage, parsedMessage.forModule);
    }
    if (event.detail?.title == 'Rider Verification Notification') {
      this.RiderVerifiedWeb(event.detail?.data);
    }
  }

  runContiniously() {
    console.log('Run Continiously', this.manageBeepAndTextList);
    console.log('Run Continiously1', this.message);
    this.intervalId = setInterval(() => {
      this.message = '';
      let beep = 'No';
      this.manageBeepAndTextList = this.persistenceService.get('manageBeepAndTextList');

      if (!this.manageBeepAndTextList || this.manageBeepAndTextList.trim() === '') {
        console.log("No data found in manageBeepAndTextList");
        return;
      }

      let mainData: string[] = this.manageBeepAndTextList.split(';;;;;');
      let extractedMessages: string[] = [];

      for (let i = 0; i < mainData.length; i++) {
        let eachData: string[] = mainData[i].split('=====');
        console.log(`Data ${i}:`, eachData); // Debugging log

        if (eachData.length >= 2) {
          let fullMessage = eachData[1]?.trim();

          // Extract ReadMessageYesNo using regex
          let readMessageMatch = fullMessage.match(/ReadMessageYesNo:(Yes|No)/);
          let readMessageYesNo = readMessageMatch ? readMessageMatch[1] : 'No';

          console.log(`Extracted ReadMessageYesNo:`, readMessageYesNo);

          if (readMessageYesNo === 'Yes') {
            let messageTitle = fullMessage.split('===')[0].trim();
            extractedMessages.push(messageTitle);
          }
        }
      }

      // Join extracted messages with `|`
      this.message = extractedMessages.join(' | ');
      console.log('Filtered Messages:', this.message);

      if (beep == 'Yes') {
        // this.beep();
      }
      if (this.message.length > 0) {
        console.log('Message Total2', this.message);
        this.textToSpeech(this.message);
      }
    }, 15 * 1000);
  }

  beep() {
    if (this.getOS() != 'Android') {
      var context = new AudioContext();
      var oscillator = context.createOscillator();
      oscillator.type = 'sine';
      oscillator.frequency.value = 800;
      oscillator.connect(context.destination);
      oscillator.start();
      setTimeout(function () {
        oscillator.stop();
      }, 100);
    }
  }

  textToSpeech(txt: string) {
    if (this.getOS() != 'Android') {
      // if ('speechSynthesis' in window) {
      //   let msg = new SpeechSynthesisUtterance();
      //   msg.voice = speechSynthesis.getVoices()[0];
      //   msg.lang = 'en';
      //   msg.rate = 1;
      //   msg.volume = 1;
      //   msg.pitch = 0.5;
      //   msg.text = txt;
      //   speechSynthesis.speak(msg);
      // }
      this.playBeepAndAudio(txt);
    }
  }

  private isPlaying = false;
  private messageQueue: string[] = [];
  async playBeepAndAudio(inputString: string) {
    if (!inputString || typeof inputString !== 'string') {
      console.error("Received invalid inputString:", inputString);
      return;
    }

    console.log("Received Input:", inputString);

    // Split messages by `|` and trim spaces
    const messages = inputString.split('|').map(msg => msg.trim());

    // **Avoid duplicate messages**
    messages.forEach(msg => {
      if (!this.messageQueue.includes(msg)) {
        this.messageQueue.push(msg);
      }
    });

    console.log("MessageQueue:", this.messageQueue, "IsPlaying=>", this.isPlaying);

    // Start processing only if not already playing
    if (!this.isPlaying) {
      this.isPlaying = true;
      try {
        await this.processQueue();
      } catch (error) {
        console.error("Error processing queue:", error);
      } finally {
        this.isPlaying = false;
      }
    }
  }

  private async processQueue() {
    while (this.messageQueue.length > 0) {
      const messageBody = this.messageQueue.shift(); // Get first message
      if (!messageBody) continue;

      try {
        console.log("Processing message:", messageBody);

        await this.ensureUserInteraction();
        await this.playBeepFile(messageBody);
        await this.playAudioFile(messageBody);
      } catch (error) {
        console.error("Error during playback:", error);
      }
    }

    // **Mark as not playing after queue is fully processed**
    this.isPlaying = false;
  }


  // Ensures user interacts with the page before playing sounds
  private async ensureUserInteraction(): Promise<void> {
    return new Promise((resolve) => {
      if (document.visibilityState === "visible") {
        resolve();
      } else {
        console.warn("Waiting for user interaction before playing sound...");
        document.addEventListener("click", () => resolve(), { once: true });
      }
    });
  }

  // Function to play different beep sounds based on `messageBody`
  playBeepFile(messageBody: string): Promise<void> {
    return new Promise((resolve) => {
      let beep = new Audio();

      // Select different beep files based on `messageBody`
      switch (messageBody) {
        case "New Delivery Request":
          beep.src = "assets/sound/New delivery available beep.mp3";
          break;
        default:
          beep.src = "assets/sound/announcement.mp3"; // Default fallback
      }

      console.log("Playing Beep for:", messageBody, "->", beep.src);
      beep.load();
      beep.play().then(() => {
        console.log("Beep Started for:", messageBody);
      }).catch(error => {
        console.error("Beep play failed:", error);
        resolve(); // Continue execution even if the beep fails
      });

      // Resolve when beep finishes
      beep.onended = () => {
        console.log('Beep Finished for:', messageBody);
        resolve();
      };
    });
  }

  // Function to play different audio messages
  playAudioFile(messageBody: string): Promise<void> {
    return new Promise((resolve) => {
      let audio = new Audio();

      // Select correct audio file based on `messageBody`
      switch (messageBody) {
        case "New Delivery Request":
          audio.src = "assets/sound/New delivery available.mp3";
          break;
        default:
          audio.src = "assets/sound/announcement.mp3"; // Default fallback
      }

      console.log("Playing Audio for:", messageBody, "->", audio.src);
      audio.load();
      audio.play().then(() => {
        console.log("Audio Started for:", messageBody);
      }).catch(error => {
        console.error("Audio play failed:", error);
        resolve(); // Continue execution even if the audio fails
      });

      // Resolve when audio finishes
      audio.onended = () => {
        console.log('Finished Audio for:', messageBody);
        resolve();
      };
    });
  }

  public webOrderRequest(refNo: string, message: string, beep: string, readMessage: string, forModule: string): void {
    if (this.manageBeepAndTextList?.length == 0) this.confirmDialogOpen = false;
    if (this.manageBeepAndTextList != null) {
      if (this.manageBeepAndTextList.length > 0) {
        let mainData: string[] = this.manageBeepAndTextList.split(';;;;;');
        for (let i = 0; i < mainData.length; i++) {
          let eachData: string[] = mainData[i].split('=====');
          if (eachData.length > 2) {
            if (forModule == eachData[4] && refNo == eachData[0]) {
              console.log('Same Order Again');
              // return;
            }
          }
        }
      }
      if (this.manageBeepAndTextList.length > 0) {
        this.manageBeepAndTextList += ';;;;;' + refNo + '=====' + message;
      } else {
        this.manageBeepAndTextList = refNo + '=====' + message;
      }
    } else {
      this.manageBeepAndTextList = refNo + '=====' + message;
    }
    console.log('List While Adding  ' + this.manageBeepAndTextList);
    this.persistenceService.set('manageBeepAndTextList', this.manageBeepAndTextList);

    if (this.getOS() != 'Android')
      this.runContiniously();

    let headingMessage = this.constant.webOrderConfirmationMessage;
    let subMessage = this.constant.parkSubMessage;
    if (!this.confirmDialogOpen) {
      this.confirmDialogOpen = true;
      const dialogRef = this.dialog.open(NewOrderDialogComponent, {
        height: 'auto',
        width: '95%',
        maxWidth: '400px',
        data: { heading: headingMessage, message: message, refNo: refNo },
      });

      dialogRef.afterClosed().subscribe((result) => {
        this.confirmDialogOpen = false;
        this.persistenceService.set('manageBeepAndTextList', '');
        StopMessageAndBeep();
        console.log(result);
        if (result) {
          // Open the dialog before refreshing
          const dialogRef = this.dialog.open(NewOrderMapDialogComponent, {
            height: 'auto',
            width: '95%',
            maxWidth: '400px',
            data: { heading: headingMessage, message: message, refNo: refNo },
          });
          this.persistenceService.set('page', 'Details');

          if (['/shipping-details'].includes(window.location.pathname)) {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this.router.navigate(['/shipping-details']);
              });
          } else {
            this.router.navigate(['/shipping-details']);
          }
        }
      });
    }
  }

  cancelMessage(refNo: string, forModule: string) {
    this.tempData = '';
    this.manageBeepAndTextList = this.persistenceService.get(
      'manageBeepAndTextList'
    );
    if (this.manageBeepAndTextList != null) {
      if (this.manageBeepAndTextList.length > 0) {
        let mainData: string[] = this.manageBeepAndTextList.split(';;;;;');
        for (let i = 0; i < mainData.length; i++) {
          let eachData: string[] = mainData[i].split('=====');
          if (eachData.length > 2) {
            if (forModule == eachData[4] && refNo == eachData[0]) {
              console.log('Cancel message' + eachData[4]);
            } else {
              if (this.tempData.length > 0) {
                this.tempData +=
                  ';;;;;' +
                  eachData[0] +
                  '=====' +
                  eachData[1] +
                  '=====' +
                  eachData[2] +
                  '=====' +
                  eachData[3] +
                  '=====' +
                  eachData[4];
              } else {
                this.tempData =
                  eachData[0] +
                  '=====' +
                  eachData[1] +
                  '=====' +
                  eachData[2] +
                  '=====' +
                  eachData[3] +
                  '=====' +
                  eachData[4];
              }
            }
          }
        }
      }
      this.manageBeepAndTextList = this.tempData;
      console.log('After Cancel==' + this.tempData);
      this.persistenceService.set(
        'manageBeepAndTextList',
        this.manageBeepAndTextList
      );
    }
  }

  openNav() {
    if (this.inLoginPage) {
      this.toastrService.showErrorToast(
        'Sign-In Required: Please sign in to access.'
      );
    } else {
      document.getElementById('myNav').classList.remove('close-nav');
      document.getElementById('myNav').classList.add('open-nav');
    }
  }

  closeNav() {
    document.getElementById('myNav').classList.remove('open-nav');
    document.getElementById('myNav').classList.add('close-nav');
  }

  breadCrumbMain() {
    if (this.persistenceService.get('isVerified') != null)
      if (this.persistenceService.get('isVerified') == 'true')
        this.appitemsTravel = this.allModule;
    this.menuHeader = [];
  }

  breadCrumb(menu: any, index: number) {
    this.menuHeader.splice(index + 1, this.menuHeader.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.appitemsTravel = menu[index].items;
    }
  }

  initializeMenu() {
    const savedLabel = localStorage.getItem('selectedMenuLabel');

    if (savedLabel) {
      const menuItem = this.allModule.find((menu) => menu.label === savedLabel);
      if (menuItem) {
        this.menuChange(menuItem);
      }
    } else {
      const defaultMenu = this.allModule.find((menu) => menu.label === 'Home');
      if (defaultMenu) {
        this.menuChange(defaultMenu);
      }
    }
  }

  menuChange(menuChange: any) {

    console.log(menuChange);
    if (menuChange) {
      localStorage.setItem('selectedMenuLabel', menuChange.label);
      console.log(menuChange.label);
      this.selectedMenu = menuChange;
      this.page = menuChange.label;
      if (menuChange.label == undefined)
        return
      this.persistenceService.set('page', this.page);
      // this.appitemsTravel = [menuChange];
      // this.menuHeader.push({ label: menuChange.label, image: menuChange.image, items: menuChange.items });
      this.menuHeader = [
        {
          label: menuChange.label,
          image: menuChange.image,
          items: menuChange.items,
        },
      ];

      this.router.navigateByUrl(menuChange.internalName);
      // this.closeNav();

    }
  }

  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: this.appConfig.setting.firebase.vapId })
      .then((currentToken) => {
        if (currentToken) {
          console.log('we got the token.....' + currentToken);

          this.persistenceService.set('FirebaseToken', currentToken);
          if (this.persistenceService.get('userDetail') != undefined) {
            this.fCMMessageRegistration = new FCMMessageRegistration();
            this.fCMMessageRegistration.deviceId =
              this.persistenceService.get('DeviceID');
            this.fCMMessageRegistration.locId = parseInt(
              this.persistenceService.get('locId')
            );
            if (this.persistenceService.get('google_email') != undefined)
              this.fCMMessageRegistration.locCusId =
                this.persistenceService.get('google_email');
            else
              this.fCMMessageRegistration.locCusId =
                this.persistenceService.get('DeviceID');
            this.fCMMessageRegistration.token = currentToken;
            this.fCMMessageRegistration.deviceType = 'Web';
          }
        } else {
          console.log(
            'No registration token available. Request permission to generate one.'
          );
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
  }

  logout() {
    if (!window.location.href.includes('login')) {
      clearTimeout(this.clickTimer);
      this.onchangeStatusSubscription = this.riderService.updateStatus(this.apiUrl.updateActiveStatus, this.id, false).subscribe((response: any) => {
        console.log('Logout API Resp : ' + response.data);
      });
      if (this.getOS() == 'Android') {
        logOutApp();
        return;
      } else {
        // clearTimeout(this.clickTimer);
        // this.router.navigate(['/login']);
        console.log('Logout clicked1 == >' + this.id + ' == ' + window.location.href.includes('rider-details') + "=====" + this.jwtService.getAccessToken());
        this.onchangeStatusSubscription = this.riderService.signOutRider(this.apiUrl.signOutRider, this.jwtService.getAccessToken()).subscribe((data: any) => {
          if (data && data.status) {
            // this.onchangeStatusSubscription = this.riderService.updateStatus(this.apiUrl.updateActiveStatus, this.id, false).subscribe((data: any) => {
            //   console.log('Logout API Resp : ' + data);


            //   //this.onAccountOperation();
            // });
          } else {
            this.toastrService.showErrorToast(this.constant.logoutErrorToast);
          }
        });
      }
    } else {
      // if (this.getOS() == 'Android') {
      //   logOutApp();
      //   return;
      // } else {
      this.toastrService.showSuccessToast(this.constant.signUpWarning);
      // }
    }
    this.jwtService.removeAccessToken();
    this.persistenceService.remove('google_id');
    this.persistenceService.remove('google_email');
    this.persistenceService.remove('google_item');
    this.persistenceService.remove('google_provider');
    this.persistenceService.remove('google_loggedIn_details');
    this.persistenceService.remove('rider_details');
    this.persistenceService.remove('locId');
    this.persistenceService.remove('active_rider_status');
    this.persistenceService.remove('selectedMenuLabel');
    this.toastrService.showSuccessToast(this.constant.logoutToast);
    console.log('Logout clicked2 == >', this.persistenceService.get('google_item'));

    clearTimeout(this.clickTimer);
    // this.router.navigate(['/login']);
    // if (this.getOS() == "Android") {
    //     logOutApp();
    // }

    window.location.href = this.appConfig.setting.loginLogoutUrl + "signin?cnt=1" + "&source=" + window.location.origin + "/&target=logout";
  }

  generateUniqueID() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';
    var uuid = s.join('');
    return uuid;
  }

  getOS() {
    var uA = getWindow().navigator.userAgent || getWindow().navigator.vendor;
    if (
      /iPad|iPhone|iPod/.test(uA) ||
      (uA.includes('Mac') && 'ontouchend' in document)
    )
      return 'iOS';
    var i,
      os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    for (i = 0; i < os.length; i++)
      if (new RegExp(os[i], 'i').test(uA)) return os[i];
  }
  getQueryVariable(variable) {
    variable = variable.replaceAll('"', '');
    var query = window.location.search.substring(1).replaceAll('?source', '');
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] == variable) {
        return pair[1].replaceAll('%20', ' ');
      }
    }
  }
  profile() {
    this.menuHeader = [
      {
        label: "Profile",
        image: "",
        items: "",
      },
    ];


    this.page = 'Rider Details';
    this.persistenceService.set('page', this.page);
    this.router.navigate(['/rider-details']);
  }

  @HostListener('window:RiderNotification', ['$event'])
  RiderNotification(event) {
    console.log('New Del=1=' + event.detail?.data);

    // Parse the message body into a structured object
    const parsedMessage = this.parseMessageBody(event.detail?.data);
    console.log('New Del=1=parsedMessage=' + parsedMessage);

    const refNo = parsedMessage.refNo;
    const message = parsedMessage.message;
    const beep = parsedMessage.beep;
    const readMessage = parsedMessage.readMessage;
    console.log(
      'New Del=2=' + refNo + '==' + message + '==' + beep + '==' + readMessage
    );

    this.persistenceService.set('refNo', refNo);
    this.persistenceService.set('message', parsedMessage.message);
    this.persistenceService.set('beep', beep);
    this.persistenceService.set('readMessage', readMessage);

    this.webOrderRequest(refNo, event.detail?.data, beep, readMessage, 'Rider');
  }
  @HostListener('window:RiderVerified', ['$event'])
  RiderVerified(event) {
    this.riderDetails = JSON.parse(
      this.persistenceService.get('rider_details')
    );
    const verified = event.detail.verified;
    // this.toastrService.showSuccessToast(
    //   'Your documents verification status : ' + verified
    // );
    if (verified === 'Rejected') {
      this.persistenceService.set('isVerified', 'false');
      this.toastrService.showErrorToast('Your documents are not verified');
      this.appitemsTravel = this.allModuleWithDashboard;
      this.riderDetails.isVerified = false;
      this.persistenceService.set('active_rider_status', 'false');
      this.persistenceService.set('page', 'Dashboard');
      this.menuChange(this.allModule[0]);
      this.router.navigateByUrl('dashboard');
    } else {
      this.persistenceService.set('isVerified', 'true');
      this.toastrService.showSuccessToast('Your documents are verified');
      this.appitemsTravel = this.allModule;
      this.riderDetails.isVerified = true;
      this.persistenceService.set('active_rider_status', 'false');
    }
    this.persistenceService.set(
      'rider_details',
      JSON.stringify(this.riderDetails)
    );
  }

  RiderVerifiedWeb(event) {
    console.log(event);
    this.riderDetails = JSON.parse(
      this.persistenceService.get('rider_details')
    );
    const verified = event;
    // this.toastrService.showSuccessToast(
    //   'Your documents verification status : ' + verified
    // );
    if (verified === 'Rejected') {
      this.persistenceService.set('isVerified', 'false');
      this.toastrService.showErrorToast('Your documents are not verified');
      this.appitemsTravel = this.allModuleWithDashboard;
      this.riderDetails.isVerified = false;
      this.persistenceService.set('active_rider_status', 'false');
      this.persistenceService.set('page', 'Dashboard');
      this.menuChange(this.allModule[0]);
      this.router.navigateByUrl('dashboard');
    } else {
      this.persistenceService.set('isVerified', 'true');
      this.toastrService.showSuccessToast('Your documents are verified');
      this.appitemsTravel = this.allModule;
      this.riderDetails.isVerified = true;
      this.persistenceService.set('active_rider_status', 'false');
    }
    this.persistenceService.set(
      'rider_details',
      JSON.stringify(this.riderDetails)
    );
  }

  @HostListener('window:SSOUserDetailsPulled', ['$event'])
  SSOUserDetailsPulled(event) {
    console.log('Received SSOUserDetails');
    this.riderDetails = new RiderDetails();
    this.riderDetails.refNo = Number(event.detail.refNo);
    this.riderDetails.firstName = event.detail.firstName;
    this.riderDetails.lastName = event.detail.lastName;
    this.riderDetails.mobileNo = event.detail.mobileNo;
    this.riderDetails.email = event.detail.email;
    this.riderDetails.dob = event.detail.dob;
    this.riderDetails.education = event.detail.education;
    this.riderDetails.vehicleType = event.detail.vehicleType;
    this.riderDetails.vehicleNo = event.detail.vehicleNo;
    this.riderDetails.vehicleName = event.detail.vehicleName;
    this.riderDetails.vehicleRegNo = event.detail.vehicleRegNo;
    this.riderDetails.aadhaarNo = event.detail.aadhaarNo;
    this.riderDetails.riderSelfiePath = event.detail.riderSelfiePath;
    this.riderDetails.fromLocationCode = Number(event.detail.fromLocationCode);
    if (event.detail.activeStatus == 'true')
      this.riderDetails.activeStatus = true;
    else this.riderDetails.activeStatus = false;
    if (event.detail.isVerified == 'true') this.riderDetails.isVerified = true;
    else this.riderDetails.isVerified = false;
    this.riderDetails.aadhaarImagePath = event.detail.aadhaarImagePath;
    if (window.location.href.includes('pre-app-and')) {
      if (this.riderDetails.email != '') this.router.navigateByUrl('dashboard');
      else this.router.navigateByUrl('rider-details');
    }
  }

  @HostListener('window:FirebaseToken', ['$event'])
  FirebaseToken(event) {
    if (
      document.getElementById('deviceId').innerHTML != null ||
      document.getElementById('deviceId').innerHTML != undefined
    )
      this.persistenceService.set(
        'DeviceId',
        document.getElementById('deviceId').innerHTML
      );

    this.persistenceService.set('FirebaseToken', event.detail.token);

    this.fCMMessageRegistration = new FCMMessageRegistration();
    this.fCMMessageRegistration.deviceType = 'Mob';
    this.fCMMessageRegistration.deviceId =
      document.getElementById('deviceId').innerHTML;
    this.fCMMessageRegistration.locId = Number(
      this.persistenceService.get('locId')
    );
    this.fCMMessageRegistration.locCusId = this.persistenceService
      .get('google_email')
      .replaceAll('"', '');
    this.fCMMessageRegistration.token = event.detail.token;

    this.fCMMessageRegistration.applicationName = 'MRA';
    this.fCMMessageRegistration.token = event.detail.token;

    // this.saveFCMTokenAndDeviceData(
    //   this.fCMMessageRegistration.token,
    //   'Android'
    // );
  }

  @HostListener('window:LongLatRec', ['$event'])
  LongLatRec(event) {
    console.log(
      'Received Lat App==' +
      event.detail.lat +
      '==Long==' +
      event.detail.long +
      '====active_rider_status===' +
      this.persistenceService.get('active_rider_status')
    );
    this.persistenceService.set('latitude', event.detail.lat);
    this.persistenceService.set('longitude', event.detail.long);
    //Changed To Android Side
    // this.updateRiderPosition(event.detail.long, event.detail.lat);
  }
  private clickTimer: any; // Variable to hold the timer
  getLatLongWeb() {
    if (getWindow().navigator.geolocation) {
      getWindow().navigator.geolocation.getCurrentPosition((position) => {
        this.updateRiderPosition(
          position.coords.longitude.toString(),
          position.coords.latitude.toString()
        );
      });
    }
    this.clickTimer = setInterval(() => {
      if (getWindow().navigator.geolocation) {
        getWindow().navigator.geolocation.getCurrentPosition((position) => {
          this.updateRiderPosition(
            position.coords.longitude.toString(),
            position.coords.latitude.toString()
          );
        });
      }
      console.log('Timer..');
    }, 120000);
  }

  updateRiderPosition(long: any, lat: any) {
    this.riderLocation.email = this.persistenceService.get('google_email');
    this.riderLocation.longitude = long;
    this.riderLocation.latitude = lat;

    this.persistenceService.set('latitude', lat);
    this.persistenceService.set('longitude', long);

    console.log(
      'Received LongLat Save=' +
      this.riderLocation.email +
      '====' +
      this.riderLocation.longitude +
      '===' +
      this.riderLocation.latitude
    );
    if (
      this.riderLocation.email != null &&
      this.riderLocation.longitude != null &&
      this.riderLocation.latitude != null
    ) {
      if (this.persistenceService.get('active_rider_status') == 'true') {
        console.log('Updating Rider Data ' + VERSION.major);
        this.riderService
          .updateRiderPosition(
            this.apiUrl.updateRiderPositionByEmailId,
            this.riderLocation
          )
          .subscribe(
            (data: any) => {
              console.log('Rider Data Updated');
              sessionStorage.setItem('Rider Data', data);
            },
            (error) => {
              console.log('Rider Data Updating Error : ' + error);
            }
          );
      } else {
        console.log('Rider Data Not Updating As Offline');
      }
    }
  }

  onChange(toggle: MatSlideToggleChange) {
    this.onchangeToggleStatusSubscription = this.createRiderService
      .updateStatus(
        this.apiUrl.updateActiveStatus,
        this.riderEmail,
        toggle.checked
      )
      .subscribe(
        (data: any) => {
          this.toastrService.showSuccessToast(this.constant.statusUpdateToast);
          this.DashboardStatus = toggle.checked;
          this.riderDetails.activeStatus = this.DashboardStatus;
          this.persistenceService.set(
            'rider_details',
            JSON.stringify(this.riderDetails)
          );
          this.persistenceService.set(
            'active_rider_status',
            this.DashboardStatus == true ? 'true' : 'false'
          );
          getWindow().navigator.geolocation.getCurrentPosition((position) => {
            this.updateRiderPosition(
              position.coords.longitude.toString(),
              position.coords.latitude.toString()
            );
          });
        },
        (error: HttpErrorResponse) => { }
      );
  }

  notificationClicked() {
    const refNo = this.persistenceService.get('refNo');
    const message = this.persistenceService.get('message');
    const beep = this.persistenceService.get('beep');
    const readMessage = this.persistenceService.get('readMessage');
    if (
      refNo == 'NA' ||
      message == 'NA' ||
      beep == 'NA' ||
      readMessage == 'NA' ||
      refNo == 'null' ||
      message == 'null' ||
      beep == 'null' ||
      readMessage == 'null' ||
      refNo == null ||
      message == null ||
      beep == null ||
      readMessage == null
    )
      this.toastrService.showErrorToast('No notification to show');
    else
      pushPullData(
        refNo + '====' + message + '====' + beep + '====' + readMessage
      );
  }

  saveFCMTokenAndDeviceData(currentToken: string, source: string) {
    if (
      this.persistenceService.get('google_email') != null &&
      this.persistenceService.get('locId') != null &&
      this.fCMMessageRegistration.deviceId != null &&
      !window.location.toString().includes('login') &&
      this.fCMMessageRegistration.token != null
    ) {
      // alert("9999999")
      // console.log('FCM Token Saved For : '+source);
      // console.log('FCM Web Token deviceId=' + this.fCMMessageRegistration.deviceId);
      // console.log('FCM Web Token currentToken=' + currentToken);
      // console.log('FCM Web Token token=' + this.token);
      // console.log('FCM Web Token locId=' + this.persistenceService.get('locId'));
      // console.log('FCM Web Token access_token=' + this.persistenceService.get('access_token'));
      // console.log('FCM Web Token token=' + this.fCMMessageRegistration.token);

      this.fCMMessageRegistration.applicationName = 'MRA';

      // alert("1="+this.fCMMessageRegistration.applicationName)
      // alert("2="+this.fCMMessageRegistration.deviceId)
      // alert("3="+this.fCMMessageRegistration.deviceType)
      // alert("4="+this.fCMMessageRegistration.locCusId)
      // alert("5="+this.fCMMessageRegistration.locId)
      // alert("6="+this.fCMMessageRegistration.token)

      this.riderService
        .saveFCMRegistrationData(
          this.apiUrl.saveUsersaveTokenIdLocId,
          this.fCMMessageRegistration
        )
        .subscribe((data: any) => {
          console.log('FCM Token Saved For Web in DB');
          this.token = currentToken;
        });
    }
  }

  helpClick() {
    const dialogRef = this.dialog.open(HelpDialogComponent, {
      height: '84%',
      width: '90%',
      maxWidth: '90%',
      // data: { heading: headingMessage }
    });
  }

  // account() {
  //   this.page = 'Rider Accounts';
  //   this.persistenceService.set('page', this.page);
  //   this.router.navigate(['/rider-accounts']);
  // }

  // ratings() {
  //   this.page = 'Ratings';
  //   this.persistenceService.set('page', this.page);
  //   this.router.navigate(['/ratings']);
  // }\
  @HostListener('window:CancelMessage', ['$event'])
  CancelMessage(event) {
    console.log('New Del=1=' + event.detail?.data);
    const parsedMessage = this.parseMessageBody(event.detail?.data);
    let refNo: string = parsedMessage.refNo;
    let forModule: string = parsedMessage.forModule;
    this.cancelMessage(refNo, forModule);
  }

  testPush(id: any) {
    id = id.replaceAll("\"", "")
    let stompClient = this.webSocketService.connect();
    stompClient.connect(
      {},
      (frame) => {
        stompClient.subscribe('/topic/' + id + '/notification', (notifications) => {
          alert(notifications.body);
        });
      },
      (err) => {
        if (err.includes('Lost connection, Re-Connecting ....')) {
          setTimeout(() => {
            this.testPush(id);
          }, 20000);
        }
      }
    );
  }

  getParamValueQueryString(paramName: string) {
    const url = window.location.href;
    let paramValue;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(paramName);
    }
    return paramValue;
  }
}
